
if (typeof window._env_.REACT_APP_RUN_MODE == 'undefined') {
    window._env_.REACT_APP_RUN_MODE = import.meta.env.VITE_RUN_MODE;
}
let url = "";
// A demo build always talks to a relative /api, in both modes. What answers
// it differs:
//
//   mock   the window.fetch interceptor in lib/demo, which never reaches a
//          network
//   live   the Cloudflare Pages Function in app/functions, which proxies to
//          the real API server-side — so the browser makes no cross-origin
//          request and CORS never applies
//
// Relative is also the safe default on its own: if the interceptor were
// somehow absent in mock mode, a request would hit the demo origin rather than
// falling through to production, which is what the final `else` does for every
// unrecognised hostname.
if (import.meta.env.VITE_DEMO_MODE) {
    url = "/api";
} else if (import.meta.env.VITE_API_URL) {
    url = import.meta.env.VITE_API_URL;
} else {
    const origin = window.location.origin;
    // Any private/LAN IP or localhost → use Vite proxy (/api → localhost:7071)
    const isLocal =
        origin.includes("localhost") ||
        /https?:\/\/(10\.|172\.(1[6-9]|2[0-9]|3[01])\.|192\.168\.|100\.(6[4-9]|[7-9][0-9]|1([01][0-9]|2[0-7]))\.)/.test(origin);
    if (isLocal) {
        url = "/api";
    } else if (origin.includes("web.sizewall.com")) {
        console.log("Using production API URL https://api.sizewall.com/api");
        url = "https://api.sizewall.com/api";
    } else {
        url = "https://api.sizewall.com/api";
    }
}
export const PIPEDB_URL = url;

